<template>
    <div id="GeUN">
        <h1>UN-Nummer</h1>
    </div>
</template>